export default class ContactViewModel {
    url: string = "";
    comment: string = "";
    additional: string = "";
    auditCode: string = "";
}
